export const FETCH_TECHNOLOGIES_REQ = "FETCH_TECHNOLOGIES_REQ";
export const FETCH_TECHNOLOGIES_ERR = "FETCH_TECHNOLOGIES_ERR";
export const FETCH_TECHNOLOGIES_SUCCESS = "FETCH_TECHNOLOGIES_SUCCESS";

export const CHANGE_ISCHECKED_VALUE = "CHANGE_ISCHECKED_VALUE";
export const RESET_IS_CHECKED_VALUE = "RESET_IS_CHECKED_VALUE"
